import { MealScan } from "@/features/portal/components/meal-scan";
import { Accent, SplitFeature } from "@/features/portal/components/portal-ui";
import { ProgressRing } from "@/features/portal/components/progress-ring";
import { m } from "@/paraglide/messages.js";
import { getLocale } from "@/paraglide/runtime.js";

/** The sample lunch the drawing recognises, and how much of the day it fills. Not anyone's real diet. */
const MACROS = [
  { id: "protein", name: () => m.portal_macro_protein(), grams: 48, share: 0.72 },
  { id: "carbs", name: () => m.portal_macro_carbs(), grams: 58, share: 0.54 },
  { id: "fat", name: () => m.portal_macro_fat(), grams: 9, share: 0.22 },
];
const EATEN = 1840;
const GOAL = 2400;

const kcal = (amount: number) => amount.toLocaleString(getLocale());

/**
 * Counting calories from a photo of the plate, told beside its picture: the picture is the
 * feature, so it gets the room.
 */
export const DietScan = () => (
  <SplitFeature
    id="diet"
    eyebrow={
      <>
        {m.portal_diet_eyebrow()}
        <em className="ml-1.5 rounded-full bg-primary px-2.5 py-1 text-[11px] tracking-[0.04em] text-primary-foreground not-italic">
          {m.portal_diet_badge()}
        </em>
      </>
    }
    title={
      <>
        {m.portal_diet_title_lead()}
        <br />
        <Accent>{m.portal_diet_title_tail()}</Accent>
      </>
    }
    body={m.portal_diet_body()}
  >
    <MealScan className="min-h-[340px] md:min-h-[400px]" />
    <div className="flex flex-col gap-3 rounded-[18px] bg-background p-4 shadow-[0_14px_30px_color-mix(in_oklch,var(--primary)_14%,transparent)]">
      <span className="text-[13px] text-muted-foreground">{m.portal_scan_meal()}</span>
      <b className="text-[56px] leading-none font-medium tracking-[-0.05em] tabular-nums">
        533
        <small className="ml-1 text-base font-normal tracking-normal text-muted-foreground">
          {m.portal_unit_kcal()}
        </small>
      </b>
      {MACROS.map((macro) => (
        <div key={macro.id} className="grid gap-1.5">
          <div className="flex justify-between text-[13px]">
            {macro.name()}
            <span className="text-muted-foreground tabular-nums">{m.portal_grams({ amount: macro.grams })}</span>
          </div>
          <div className="h-2 overflow-hidden rounded-full bg-[var(--site-well)]">
            <i className="block h-full rounded-full bg-primary" style={{ width: `${macro.share * 100}%` }} />
          </div>
        </div>
      ))}
      <div className="mt-auto flex items-center gap-3.5 pt-2">
        <ProgressRing share={EATEN / GOAL} size={64} stroke={8} />
        <div>
          <b className="block text-[15px] font-semibold tabular-nums">
            {m.portal_kcal_of({ eaten: kcal(EATEN), goal: kcal(GOAL) })}
          </b>
          <small className="text-[13px] text-muted-foreground">{m.portal_scan_goal()}</small>
        </div>
      </div>
    </div>
  </SplitFeature>
);
